import React from 'react'
import { Trans } from 'react-i18next'

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true }
  }

  componentDidCatch(error, errorInfo) {
    // You can also log the error to an error reporting service
    window.Rollbar.error(error)
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return <Trans parent="h3">core.errors.went_wrong_contact_support</Trans>
    }

    return this.props.children
  }
}

export default ErrorBoundary
